export class SmartController {
    constructor(axios) {
        this.axios = axios;
    }
    async search(input) {
        try {
            const response = await this.axios.post("/smart/search", {
                input,
            });
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
}
